<template>
  <div class="info">
    <img src="@/assets/images/png/nullData.png" alt="" />
    <p>内容为空</p>
  </div>
</template>

<script>
export default {
  name: "info",

  data() {
    return {};
  },

  mounted() {},

  methods: {},
};
</script>

<style scoped>
.info {
  width: 100%;
  display: flex;
  flex-direction:column;
  align-items: center;
  padding-top: 120px;

  color: #999;
}

.info img {
  width: 160px;
  margin-bottom: 20px;
}
</style>


// WEBPACK FOOTER //
// src/components/nullData.vue